import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ViewerHomeComponent } from './components/viewer-home/viewer-home.component';
import { ReportsMenuComponent } from './components/report-and-info/reports-menu/reports-menu.component';
import { WeeklyScheduleDrillComponent } from './components/schedules-and-labor/weekly-schedule-drill/weekly-schedule-drill.component';
import { MaintScheduleJobsComponent } from './components/schedules-and-labor/maint-schedule-jobs/maint-schedule-jobs.component';
import { WeeklyScheduleMxComponent } from './components/schedules-and-labor/weekly-schedule-mx/weekly-schedule-mx.component';
import { VarianceReportComponent } from './components/report-and-info/variance-report/variance-report.component';
import { TrackReportsComponent } from './components/report-and-info/track-reports/track-reports.component';

const routes: Routes = [
  {
    path: '',
    component: ViewerHomeComponent,
  },
  {
    path: 'reports-menu',
    component: ReportsMenuComponent,
  },
  {
    path: 'weekly-schedule-drill',
    component: WeeklyScheduleDrillComponent,
  },
  {
    path: 'maint-schedule-jobs',
    component: MaintScheduleJobsComponent,
  },
  {
    path: 'weekly-schedule-mx',
    component: WeeklyScheduleMxComponent,
  },
  {
    path: 'variance-report',
    component: VarianceReportComponent,
  },
  {
    path: 'track-reports',
    component: TrackReportsComponent,
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
